<template>
    <b-modal class="modal-content" ref="mdlFasciaOrariaComponent" title="Fascia Oraria" @hide="onHide"
        no-close-on-backdrop no-close-on-select>
        <div class="modal-body">
            <b-row>
                <b-col>
                    <label for="dataInizio">Ora Inizio</label>
                    <date-picker format="HH:mm" value-type="timestamp" v-model="setDalleOre" type="time"></date-picker>
                </b-col>
                <b-col>
                    <label for="indirizzo">Ora Fine</label>
                    <date-picker format="HH:mm" value-type="timestamp" v-model="setAlleOre" type="time"></date-picker>
                </b-col>
                <b-col>
                    <label for="indirizzo">Numero accessi</label>
                    <b-form-spinbutton v-model="jsonData.numeroAccessi" min="1" max="100"></b-form-spinbutton>
                </b-col>
            </b-row>
        </div>
        <template #modal-footer>
            <div class="d-flex justify-content-end w-100">
                <b-button size="sm" variant="danger" class="ml-2" @click="close"> Annulla

                </b-button>
                <b-button size="sm" variant="success" class="ml-2" @click="oOkMdlFasciaOrariaComponent"> {{
                    isModifica ? "Modifica Fascia Oraria" : "Salva Fascia Oraria" }}
                </b-button>



            </div>
        </template>
    </b-modal>
</template>

<script>
import DatePicker from "vue2-datepicker";
import toast from "../../../template/layout/utility/sa-toast";
import moment from "moment";
export default {
    components: { DatePicker },
    data() {
        return {
            jsonData: { dalleOre: null, alleOre: null, numeroAccessi: 1 },
            intervallo: null,
            intervalloParametroSel: null,
            isModifica: false,
        };
    },
    computed: {
        setDalleOre: {
            get: function () {
                return this.jsonData.dalleOre;
            },
            set: function (value) {
                this.jsonData.dalleOre = value;
            },
        },
        setAlleOre: {
            get: function () {
                return this.jsonData.alleOre;
            },
            set: function (value) {
                this.jsonData.alleOre = value;
            },
        },
        setClsColor: {
            get: function () {
                return this.jsonData.clsColor;
            },
            set: function (value) {
                this.jsonData.clsColor = value;
            },
        },
    },
    methods: {
        show() {
            let me = this;
            me.$refs.mdlFasciaOrariaComponent.show();
        },
        close() {
            let me = this;
            me.$refs.mdlFasciaOrariaComponent.hide();
        },
        oOkMdlFasciaOrariaComponent() {
            let me = this;
            let validation = me.validazione();
            if (!validation.esito) {
                me.generaBtoast(validation);
                return;
            }
            let fasciaOraria = { dalleOre: moment(this.jsonData.dalleOre).format("HH:mm"), alleOre: moment(this.jsonData.alleOre).format("HH:mm"), numeroAccessi: me.jsonData.numeroAccessi };



            this.isModifica ? this.$emit("modificaFasciaOraria", fasciaOraria, this.intervalloParametroSel.intervalloIndex, this.intervalloParametroSel.parametroIndex) : this.$emit("addFasciaOraria", fasciaOraria, this.intervalloParametroSel.index);
            this.close();
        },
        nuovoIntervalloTemporale(parameter) {
            this.intervalloParametroSel = parameter;
            this.isModifica = false;
            this.show();
        },
        modificaIntervalloParametro(parameter) {
            this.isModifica = true;
            this.intervalloParametroSel = parameter;
            this.jsonData = JSON.parse(JSON.stringify(parameter.intervallo));
            this.jsonData.alleOre = this.timeStringToTimestamp(parameter.intervallo.alleOre);
            this.jsonData.dalleOre = this.timeStringToTimestamp(parameter.intervallo.dalleOre);
            this.show();
        },

        onHide() {
            this.jsonData = { dalleOre: null, alleOre: null, numeroAccessi: 1 }
            this.intervalloParametroSel = null;
            this.isModifica = false;
            this.intervallo = null;
        },
        generaBtoast(validation) {
            toast.validation(validation)
        },
        validazione() {
            let esito = true;
            let msg = "";
            if (this.jsonData.dalleOre == null) {
                msg += "Dalle Ore Obbligatorio ! #";
                esito = false;
            }
            if (this.jsonData.alleOre == null) {
                msg += "Alle Ore Obbligatorio ! #";
                esito = false;
            }
            if (this.jsonData.numeroAccessi < 1) {
                msg += "Il numero accessi deve essere almeno di 1 ! #";
                esito = false;
            }
            return { esito: esito, msg: msg };
        },
        timeStringToTimestamp(timeStr) {
            const dataFissa = new Date('1970-01-01T00:00:00');
            const [ore, minuti] = timeStr.split(':');
            dataFissa.setHours(parseInt(ore, 10));
            dataFissa.setMinutes(parseInt(minuti, 10));
            return dataFissa.getTime();
        }

    },
};
</script>

<style></style>
